import type { EntryPoint } from '#packages/apilib';
import { PluginServiceApiKey } from '#packages/apis';
import { createPluginServiceApi } from './pluginService';

export const PluginServiceEntrypoint: EntryPoint = {
  name: 'PluginServiceApi',
  declareAPIs: () => [PluginServiceApiKey],
  getDependencyAPIs: () => [],
  attach(shell) {
    shell.contributeAPI(PluginServiceApiKey, () => createPluginServiceApi());
  },
};
